import { createClient } from 'graphql-ws';
import { getRequest, type Disposable } from 'relay-runtime';

import type { useAgentSessionsLiveUpdatesSubscription as Subscription } from './__generated__/useAgentSessionsLiveUpdatesSubscription.graphql';
import { useAgentSessionsLiveUpdatesSubscription } from './useAgentSessionsLiveUpdatesSubscription';

/** Temporary Home-only transport until the host Relay environment supports workspace routing. */
export const subscribeToHomeAgentSessions = (
	variables: Subscription['variables'],
	rovoActivationId: string,
	onNext: () => void,
	onError: (error: unknown) => void,
): Disposable | undefined => {
	if (
		typeof window === 'undefined' ||
		!['home.atlassian.com', 'home.stg.atlassian.com'].includes(window.location.hostname)
	) {
		return undefined;
	}

	const { params } = getRequest(useAgentSessionsLiveUpdatesSubscription);
	const build = window as Window & { BUILD_KEY?: string; SSR_BUILD_KEY?: string };
	const client = createClient({
		url: `${window.location.origin.replace(
			/^http/,
			'ws',
		)}/gateway/api/graphql/subscriptions/rovo/workspace/${encodeURIComponent(rovoActivationId)}`,
		lazy: true,
		// Match the shared AGG client's keepalive (UCT refresh) and reconnect policy.
		keepAlive: 580_000,
		retryAttempts: 100,
		connectionParams: {
			'atl-client-name': 'jira-frontend',
			'atl-client-version': `${build.BUILD_KEY ?? ''}::${build.SSR_BUILD_KEY ?? ''}`,
			'X-ExperimentalApi': 'ConvoAiInboxSessionChanged',
		},
	});
	const unsubscribe = client.subscribe<Subscription['response']>(
		{
			query: '',
			operationName: params.name,
			variables,
			extensions: { pq: params.id },
		},
		{
			next: ({ data, errors }) => {
				if (!errors?.length && data?.convoai_onInboxSessionChanged?.session != null) onNext();
			},
			error: onError,
			complete: () => {},
		},
	);
	return {
		dispose: () => {
			unsubscribe();
			void client.dispose();
		},
	};
};
